import {createSlice} from "@reduxjs/toolkit";
import {toast} from "react-toastify";
import {t} from "i18next";
import {ResponseApi} from "../BaseApi";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */



const distributionCenterSectionSlice = createSlice({
    name: 'distributionCenterSection',
    initialState: {
        getAllDistributionCenter: {},
        createDistributionCenter: {},
        updateDistributionCenter: {},
        deleteDistributionCenter: {},
        listOfUsersDistributionCenter: {},
        getAllNonDistributionCenterUser: [],

    },
    reducers: {},
    extraReducers: {
        'distributionCenterSection/getAllDistributionCenter/fulfilled': (state, action) => {
            state.getAllDistributionCenter = ResponseApi(action.payload);
        },
        'distributionCenterSection/createDistributionCenter/fulfilled': (state, action) => {
            state.createDistributionCenter = ResponseApi(action.payload);
        },

        'distributionCenterSection/updateDistributionCenter/fulfilled': (state, action) => {
            state.updateDistributionCenter = ResponseApi(action.payload);
        },
        'distributionCenterSection/deleteDistributionCenter/fulfilled': (state, action) => {
            state.deleteDistributionCenter = ResponseApi(action.payload);
        },
        'distributionCenterSection/listOfDistributionCenter/fulfilled': (state, action) => {
            state.listOfUsersDistributionCenter = ResponseApi(action.payload);
        },
        'distributionCenterSection/getAllNonDistributionCenter/fulfilled': (state, action) => {
            state.getAllNonDistributionCenterUser = ResponseApi(action.payload);
        },
    },
});

export const {} = distributionCenterSectionSlice.actions;

export default distributionCenterSectionSlice.reducer;
